"use client";

import Breadcrumb from "@/components/Common/Breadcrumb";
import { getImagePath } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";
import Image from "next/image";
import { useTranslations } from "next-intl";

const AboutPage = () => {
  const t = useTranslations("aboutus");

  return (
    <section className="section-padding bg-white py-24">
      <Breadcrumb
        pageName={t("pageName")}
        description=""
        bgImages={[getImagePath("/images/breadcrumb/aboutUs.webp")]}
        bgIndex={0}
      />

      <div className="container flex flex-col md:flex-row gap-10 md:gap-20 items-center justify-center mx-auto px-6 py-10">
        <div className="w-00 md:w-10/12 text-gray-700 text-lg leading-relaxed">
          <p>{t("intro")}</p>
        </div>

        <div>
          <img
            src={getImagePath("/images/about/about-r.png")}
            alt={t("pageName")}
            className="w-full h-auto rounded-lg"
          />
        </div>
      </div>

      <div className="container mx-auto px-4 grid md:grid-cols-2 gap-10">
        <Card className="bg-transparent border-0 hover-lift rounded-none overflow-hidden shadow-none lift">
          <div className="relative h-auto rounded-tr-[40px] rounded-bl-[40px]">
            <Image
              src={getImagePath("/images/about/about-1.png")}
              alt={t("why_title")}
              width={960}
              height={640}
              className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </div>
          <CardContent className="px-2 pt-4">
            <h3 className="text-xl font-bold text-primary mb-3 max-h-20">
              {t("why_title")}
            </h3>
            <p className="text-warm-300 leading-relaxed pt-2">
              {t("why_desc")}
            </p>
          </CardContent>
        </Card>

        <Card className="bg-transparent border-0 hover-lift rounded-none overflow-hidden shadow-none lift">
          <div className="relative h-auto rounded-tr-[40px] rounded-bl-[40px]">
            <Image
              src={getImagePath("/images/about/about-2.png")}
              alt={t("target_title")}
              width={960}
              height={640}
              className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </div>
          <CardContent className="px-2 pt-4">
            <h3 className="text-xl font-bold text-primary mb-3 max-h-20">
              {t("target_title")}
            </h3>
            <p className="text-warm-300 leading-relaxed pt-2">
              {t("target_desc")}
            </p>
          </CardContent>
        </Card>
      </div>

      <h1 className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-16 w-full p-0 md:px-8 text-center max-w-4xl mx-auto text-2xl md:text-4xl font-bold text-primary">
        <span>{t("one_screen")}</span>
        <span>{t("one_story")}</span>
        <span>{t("one_family")}</span>
      </h1>
    </section>
  );
};

export default AboutPage;
